export default __webpack_public_path__ + "static/media/traffic_officer.33a93a36.svg";